import React, { useState } from "react";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import HeaderTable from "../../../components/generic/HeaderTable";
import HeaderGeneric from "../../../components/generic/headerGeneric";
import {
  CommandBar,
  IColumn,
  ICommandBarItemProps,
  Icon,
  SearchBox,
  SelectionMode,
  TooltipHost,
} from "@fluentui/react";
import IconHelper from "../../../utils/helpers/iconHelper";
import { HeaderGestionDocumentos } from "../general/HeaderGestionDocumentos";
import { IDataTablePersonas } from "../../../Interfaces/IPersona";
import COLORES from "../../../utils/theme/colores";
import themeBase from "../../../utils/theme/themeBase";
import { ConfigHelper } from "../../../utils/helpers/configHelper";
import { useNavigate } from "react-router-dom";
import { TableBase2 } from "../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../components/PaginationFooter/PaginationFooterC";
import { TableV8 } from "../../../components/Table/TablaV8";
import { PaginationV8 } from "../../../components/PaginationFooter/PaginationV8";
import { PanelRegistrarTipo } from "./PanelRegistrarTipo";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelEliminarTipo } from "./PanelEliminarTipo";
import { PanelEditarTipo } from "./PanelEditarTipo";
import { useVistaTiposDocumentos } from "../hooks/useVistaTiposDocumentos";
import { ITablaTiposDocumentos } from "../../../Interfaces/gestionDocumentos/ITipoDocumento";

export const VistaTiposDocumentos = () => {
  const navigate = useNavigate();
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);
  const [
    isOpenEliminar,
    { setTrue: openPanelEliminar, setFalse: dismissPanelEliminar },
  ] = useBoolean(false);

  const [
    isOpenEditar,
    { setTrue: openPanelEditar, setFalse: dismissPanelEditar },
  ] = useBoolean(false);

  const {
    loading,
    items,
    filter,
    setFilter,
    limpiarFiltro,
    postListaTabla,
    paginacionTable,
    onChangeTextSearch,
  } = useVistaTiposDocumentos();

  const [value, setValue] = useState<ITablaTiposDocumentos>(null!);

  const _itemBack: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BACK2,
      onClick: () => {
        navigate(
          `${ConfigHelper.urlBase()}/gestionDocumentos
              `
        );
      },
    },
  ];

  const _itemsLeftBar: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD_TABLE,
      text: "Agregar Tipo",
      onClick: () => {
        openPanel();
      },
    },
    {
      ...IconHelper.ICON_RELOAD2,
      onClick: () => {
        limpiarFiltro();
      },
    },
  ];
  const _itemRigthBar: ICommandBarItemProps[] = [
    {
      key: "Search",
      onRender: (item) => {
        return (
          <div>
            <SearchBox
              // underlined
              placeholder={"Buscar"}
              onChange={onChangeTextSearch}
              value={filter.search}
              styles={{
                root: {
                  borderColor: "#bababa",
                  width: "300px",
                  height: "28px",
                  fontSize: 12,
                  borderRadius: "2px",
                },
              }}
              //   underlined={true}

              // defaultValue={props.value === null ? "" : props.value}
              // onSearch={searchHandler}
              // onChange={searchChange}
              // value={props.searchValue == null ? "" : props.searchValue}
              // autoComplete="off"
              // onClear={onClearHandler}
            />
          </div>
        );
      },
    },
  ];
  const _columns: IColumn[] = [
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      //   isSorted: true,
      //   isSortedDescending: true,
    },
    {
      key: "fecha",
      name: "Fecha de Creación",
      fieldName: "fecha",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "usuario",
      name: "Registrado Por",
      fieldName: "usuario",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
      onRender: (item: ITablaTiposDocumentos) => (
        <>
          <div style={{ display: "flex", columnGap: "5px" }}>
            <TooltipHost content="Actualizar">
              <Icon
                iconName="edit"
                style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                className={themeBase.classNamesIcon.iconFont}
                onClick={() => {
                  setValue(item);
                  openPanelEditar();
                }}
              />
            </TooltipHost>
            <TooltipHost content="Eliminar">
              <Icon
                iconName="delete"
                style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                className={themeBase.classNamesIcon.iconFont}
                onClick={() => {
                  setValue(item);
                  openPanelEliminar();
                }}
              />
            </TooltipHost>
            <TooltipHost content="Gestión de Grupos">
              <Icon
                iconName="FolderSearch"
                style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
                className={themeBase.classNamesIcon.iconFont}
                onClick={() => {
                  navigate(
                    `${ConfigHelper.urlBase()}/gestionDocumentos/grupos
                    `,
                    {
                      state: item.tipoDocumentoId,
                    }
                  );
                }}
              />
            </TooltipHost>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div>
        <HeaderGestionDocumentos
          items={_itemBack}
          title="Gestión de Tipo Documentos"
          key={"Gestión de Tipo Documentos"}
        />
        <div>
          <TableV8
            leftBar={_itemsLeftBar}
            rigthBar={_itemRigthBar}
            selectionMode={SelectionMode.none}
            data={items}
            column={_columns}
            isLoading={loading}
            footerPagination={
              <PaginationV8
                onChangeTake={paginacionTable.onChangeTake}
                onChangeSkip={paginacionTable.onChangeSkip}
                totalPagesPagination={paginacionTable.totalPagesPagination}
                skipPagination={paginacionTable.skipPagination}
                takePagination={paginacionTable.takePagination}
                isLoading={loading}
                cantidad={items?.length}
                total={paginacionTable.total}
              />
            }
          />
        </div>
      </div>

      <PanelRegistrarTipo
        isOpen={isOpen}
        onDismiss={dismissPanel}
        onRenderTable={limpiarFiltro}
      />
      <PanelEliminarTipo
        isOpen={isOpenEliminar}
        onDismiss={dismissPanelEliminar}
        onRenderTable={limpiarFiltro}
        documentoId={value?.tipoDocumentoId ?? ""}
      />
      <PanelEditarTipo
        isOpen={isOpenEditar}
        onDismiss={dismissPanelEditar}
        onRenderTable={limpiarFiltro}
        tipoDocumentoId={value?.tipoDocumentoId ?? ""}
        tipo={value?.nombre ?? ""}
      />
    </>
  );
};
